import { Colors } from "@/enums/Colors";
import { TextField, TextFieldProps, styled } from "@mui/material";

const StyledTextField = styled(TextField)(() => ({
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: "0.7rem",
    borderColor: `${Colors.LIGHT_GRAY}`,
  },
}));

function CommonTextField(props: TextFieldProps) {
  return (
    <>
      <StyledTextField {...props} />
    </>
  );
}

export default CommonTextField;
